import './../styles/Faq.css';

const FAQ_URL = 'https://www.zilliqa.com/faq/';

const FAQS = [
  {
    question: "What is Zilliqa's updated direction?",
    answer:
      'Zilliqa is building the compliance infrastructure for institutional onchain finance, running the credential check before a transaction settles rather than reconciling it after.',
  },
  {
    question: 'What is the Mediation Layer?',
    answer:
      "Zilliqa's core product sits above settlement and runs a credential check before a transaction clears: if both parties pass, it proceeds; if not, it doesn't.",
  },
  {
    question: "What does 'compliance before settlement' mean in practice?",
    answer:
      'Institutional workflows settle first and reconcile compliance after. Zilliqa inverts that sequence, so the credential check runs before anything settles.',
  },
];

export default function Faq() {
  return (
    <section className="faq">
      <span className="faq__eyebrow">FAQ</span>
      <h2>Pre-settlement compliance, answered.</h2>
      <p className="faq__subhead">Straight answers to the questions we hear most.</p>

      <div className="faq__grid">
        {FAQS.map((item) => (
          <div className="faq-item" key={item.question}>
            <h3>{item.question}</h3>
            <p>{item.answer}</p>
            <a href={FAQ_URL}>Read more →</a>
          </div>
        ))}
      </div>

      <div className="faq__cta">
        <a className="zq-btn zq-btn--solid zq-btn--lg" href={FAQ_URL}>
          Read all FAQs →
        </a>
      </div>
    </section>
  );
}